module.exports = __webpack_public_path__ + "static/site-ready-3d67a7134f2ed9d819a9cf2c4a3a66cf.png";